import { useState, useEffect, useCallback } from "react";
import URLs from "constants/urls";
import Cookie from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useMaterialUIController } from "context";

const useBusinessEntryApiCall = (typeCode, resetForm) => {
  const [controller] = useMaterialUIController(); // Get context state
  const { user } = controller; // Destructure user
  const [editStatus, setEditStatus] = useState(false);
  const [businessMasterData, setBusinessMasterData] = useState([]);
  const [providerData, setProviderData] = useState([]);
  const [finalFinanceData, setFinalFinanceData] = useState([]);
  const [dsaData, setDsaData] = useState([]);
  const [entryData, setEntryData] = useState([]);
  const [subDsaData, setSubDsaData] = useState([]);
  const [managersData, setManagersData] = useState([]);
  const [dsaManagersData, setDsaManagersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [open, setOpen] = useState(false);
  const [insuranceConfigs, setInsuranceConfigs] = useState([]);
  const [insuranceAgents, setInsuranceAgents] = useState([]);
  const jwt_token = Cookie.get("jwt_token");
  const [companyConfig, setCompanyConfig] = useState({});
  const navigate = useNavigate();
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();

  const startOfMonth = new Date(year, month, 2).toISOString().split("T")[0];
  const endOfMonth = new Date(year, month + 1, 1).toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(startOfMonth);
  const [toDate, setToDate] = useState(endOfMonth);

  function formatDate(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  let startDate, endDate;

  if (currentMonth < 3) {
    startDate = new Date(currentYear - 1, 3, 1);
    endDate = new Date(currentYear, 2, 31);
  } else {
    startDate = new Date(currentYear, 3, 1);
    endDate = new Date(currentYear + 1, 2, 31);
  }
  const formattedStartDate = formatDate(startDate);
  const formattedEndDate = formatDate(endDate);

  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const fetchCompanyConfigs = async () => {
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`, // Include the JWT token here
        },
      };
      const response = await fetch(`${URLs.companyURl}`, options);
      const data = await response.json();
      if (response.ok) {
        setCompanyConfig(data[0]);
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      setAlert(`Failed to Fetch: ${error.message}`, "error");
    }
    setLoading(false);
  };
  const fetchInsuranceConfigs = async (configId) => {
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };
      const response = await fetch(`${URLs.insuranceConfigs}/${configId}`, options);
      const data = await response.json();
      if (response.ok) {
        setInsuranceConfigs(data);
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      setAlert(`Failed to Fetch: ${error.message}`, "error");
    }
    setLoading(false);
  };
  const fetchInsuranceAgents = async (compId) => {
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };
      const response = await fetch(`${URLs.insuranceAgents}/${compId}`, options);
      const data = await response.json();
      if (response.ok) {
        setInsuranceAgents(data);
      } else {
        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      setAlert(`Failed to Fetch: ${error.message}`, "error");
    }
    setLoading(false);
  };

  const fetchFinanceDetails = async (selectedLoanType) => {
    if (!selectedLoanType) return;
    const url = `${URLs.entriesUrlById}/${selectedLoanType}`;
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`, // Include the JWT token here
        },
      };
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error("Failed to fetch finance details");
      }
      const data = await response.json();
      const sortedFinanceData = data.sort((a, b) =>
        a.finainacialInstitutionName.localeCompare(b.finainacialInstitutionName)
      );

      setFinalFinanceData(sortedFinanceData);
    } catch (error) {
      setAlert("" + error.message, "error");
    }
    setLoading(false);
  };
  const fetchFilteredFinanceDetails = async (bType, bStatus, monthId) => {
    const url = `${URLs.businessEntriesByCompanyIdAndStatus}?businessStatus=${bStatus}&businessType=${bType}&businessMonthId=${monthId}&dsaId=${user.companyId}`;
    setLoading(true);
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`, // Include the JWT token here
      },
    };
    try {
      const response = await fetch(url, options);
      const data = await response.json();
      setEntryData(data);
    } catch (error) {
      setAlert(`Data not fetched: ${error.message}`, error);
    }
    setLoading(false);
  };
  // Memoize the fetch function to prevent re-creation on each render
  const fetchEntriesFeildsData = useCallback(async () => {
    setLoading(true);
    try {
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      };

      // Step 1: Fetch Role Details
      const roleDetailsUrl = `${URLs.roleGetUrl}`;
      const roleResponse = await fetch(roleDetailsUrl, options);

      if (!roleResponse.ok) throw new Error("Failed to fetch role details");

      const roleData = await roleResponse.json();

      const dsaMngrRole = roleData.find((item) =>
        item.roleName?.toLowerCase().includes("sales manager")
      );
      const subDsaMngrRole = dsaMngrRole;

      if (!dsaMngrRole || !subDsaMngrRole) {
        throw new Error("Role data not found");
      }

      // Step 2: Fetch Employees
      const employeeDetailsUrl = `${URLs.hrmsEmployeesByCompanyId}/0`;
      const employeeResponse = await fetch(employeeDetailsUrl, options);
      if (!employeeResponse.ok) throw new Error("Failed to fetch employee data");
      const employeeData = (await employeeResponse.json()) || [];

      // Step 3: Fetch All Parallel Data
      let businessEntriesUrl = "";

      switch (typeCode) {
        case "BL":
          businessEntriesUrl = `${URLs.getEntriesByDateRange}?startDate=${formattedStartDate}&endDate=${formattedEndDate}&dsaId=${user.companyId}`;
          break;

        case "IN":
          businessEntriesUrl = `${URLs.getInsuranceEntries}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
          break;

        case "MF":
          businessEntriesUrl = `${URLs.getMutualFundEntries}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`;
          break;

        default:
          businessEntriesUrl = "";
          break;
      }

      const urls = {
        businessMasterUrl: `${URLs.financeBusinessGetUrl}/${typeCode}`,
        providerUrl: `${URLs.finanaceGetUrlByTypeCodeUrl}/${typeCode}`,
        dsaDetailsUrl: `${URLs.dsaMasterGetUrl}`,
        businessEntriesUrl: businessEntriesUrl,
      };

      const [businessMasterResponse, providerResponse, dsaResponse, entriesResponse] =
        await Promise.all(Object.values(urls).map((url) => fetch(url, options)));

      if (
        !businessMasterResponse.ok ||
        !providerResponse.ok ||
        !dsaResponse.ok ||
        !entriesResponse.ok
      ) {
        throw new Error("Failed to fetch some data");
      }

      const [businessMasterDataRaw, providerDataRaw, dsaDataRaw, businessEntriesDataRaw] =
        await Promise.all([
          businessMasterResponse.json(),
          providerResponse.json(),
          dsaResponse.json(),
          entriesResponse.json(),
        ]);

      const businessMasterData = businessMasterDataRaw || [];
      const providerData = providerDataRaw || [];
      const dsaData = dsaDataRaw || { data: [] };
      const businessEntriesData = businessEntriesDataRaw || [];

      const filteredDsaMngr = (employeeData || []).filter((item) => item?.companyId == 0);

      const filteredSubDsaData = (dsaData.data || []).filter(
        (item) => item?.dsaType === "CNT" || item?.gststatus == "N"
      );

      const sortedData = (businessMasterData || []).sort((a, b) => {
        const nameA = a?.businessName || "";
        const nameB = b?.businessName || "";
        return nameA.localeCompare(nameB);
      });

      const sortedManagers = filteredDsaMngr.sort((a, b) => {
        const nameA = a?.firstName || "";
        const nameB = b?.firstName || "";
        return nameA.localeCompare(nameB);
      });

      const sortedSubDsaData = filteredSubDsaData.sort((a, b) => {
        const nameA = a?.dsaName || "";
        const nameB = b?.dsaName || "";
        return nameA.localeCompare(nameB);
      });

      setManagersData(sortedManagers || []);
      setBusinessMasterData(sortedData || []);
      setProviderData(providerData || []);
      setDsaData(dsaData.data || []);
      setSubDsaData([{ dsaName: "Direct", dsaId: -1 }, ...(sortedSubDsaData || [])]);
      setDsaManagersData([]);
      setEntryData(businessEntriesData || []);
    } catch (error) {
      console.error("Fetch Error:", error);
      setAlert("Failed to fetch data: " + error.message, "error");
      // Optional: Set fallback data to empty arrays
      setManagersData([]);
      setBusinessMasterData([]);
      setProviderData([]);
      setDsaData([]);
      setSubDsaData([{ dsaName: "Direct", dsaId: -1 }]);
      setDsaManagersData([]);
      setEntryData([]);
    }
    setLoading(false);
  }, [typeCode]);
  const fetchBusinessEntriesApiCall = useCallback(
    async (fDate, tDate) => {
      const url = `${URLs.getEntriesByDateRange}?startDate=${fDate}&endDate=${tDate}&dsaId=${user.companyId}`;
      setLoading(true);
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`, // Include the JWT token here
        },
      };
      try {
        const response = await fetch(url, options);
        const data = await response.json();
        setEntryData(data);
      } catch (error) {
        setAlert(`Data not fetched: ${error.message}`, "error");
      }
      setLoading(false);
    },
    [typeCode]
  );
  const fetchInsuranceEntriesApiCall = useCallback(
    async (fDate, tDate) => {
      const url = `${URLs.getInsuranceEntries}&startDate=${fDate}&endDate=${tDate}`;
      setLoading(true);
      const options = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`, // Include the JWT token here
        },
      };
      try {
        const response = await fetch(url, options);
        const data = await response.json();
        setEntryData(data);
      } catch (error) {
        setAlert(`Data not fetched: ${error.message}`, "error");
      }
      setLoading(false);
    },
    [typeCode]
  );
  const postInsuranceEntry = useCallback(
    async (data, setActiveTab) => {
      setLoading(true);
      const url = `${URLs.insuranceEntry}`;
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`,
          },
          body: JSON.stringify(data),
        });

        const responseData = await response.json(); // Parse the response JSON

        if (response.ok) {
          // Ensure responseData.message is a string and handle missing cases
          const successMessage =
            typeof responseData.message === "string" ? responseData.message : "Posted Successfully";

          setAlert(successMessage, "success");
          fetchInsuranceEntriesApiCall(fromDate, toDate);
          setActiveTab(0);
          if (resetForm) resetForm();
        } else {
          // Handle errors and ensure errorMessage is a string
          const errorMessage =
            typeof responseData.message === "string"
              ? responseData.message
              : "Network response was not ok";

          throw new Error(errorMessage);
        }
      } catch (error) {
        // Ensure error.message is a string
        setAlert(`Failed to Post: ${String(error.message)}`, "error");
      }
      setLoading(false);
    },
    [fetchInsuranceEntriesApiCall, resetForm]
  );
  const putInsuranceEntry = useCallback(
    async (entryId, data, setActiveTab) => {
      setLoading(true);
      const url = `${URLs.updateInsuranceEntry}`;
      try {
        const response = await fetch(url, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`,
          },
          body: JSON.stringify(data),
        });

        if (response.ok) {
          setAlert("Updated Successfully", "success"); // Successful update alert
          fetchInsuranceEntriesApiCall(fromDate, toDate); // Fetch updated entries
          setActiveTab(0);
          if (resetForm) resetForm();
        } else {
          // Parse the error message from the JSON response
          const errorData = await response.json();
          const errorMessage = errorData.message || "Failed to Update"; // Use the server error message
          setAlert(errorMessage, "error"); // Show the error message in an alert
        }
      } catch (error) {
        setAlert("Failed to Update: " + error.message, "error"); // Handle network or other errors
      }
      setLoading(false);
    },
    [fetchInsuranceEntriesApiCall, resetForm]
  );
  const deleteInsuranceEntry = useCallback(
    async (entryId) => {
      setLoading(true);
      const url = `${URLs.deleteInsuranceEntry}/${entryId}`;
      try {
        const response = await fetch(url, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`,
          },
        });

        if (response.ok) {
          setAlert("Deleted Successfully", "success");
          fetchInsuranceEntriesApiCall(fromDate, toDate);
          if (resetForm) resetForm();
        } else {
          // If the response is not ok, parse the response body to get the error message
          const errorData = await response.json();
          setAlert(errorData.message || "Failed to Delete", "error");
        }
      } catch (error) {
        setAlert("Failed to Delete: " + error.message, "error");
      }
      setLoading(false);
    },
    [fetchInsuranceEntriesApiCall]
  );
  const postEntry = useCallback(
    async (data, setActiveTab) => {
      setLoading(true);
      const url = `${URLs.businessEntriesUrl}`;
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`,
          },
          body: JSON.stringify(data),
        });

        const responseData = await response.json(); // Parse the response JSON

        if (response.ok) {
          // Ensure responseData.message is a string and handle missing cases
          const successMessage =
            typeof responseData.message === "string" ? responseData.message : "Posted Successfully";

          setAlert(successMessage, "success");
          fetchBusinessEntriesApiCall(fromDate, toDate);
          setActiveTab(0);
          if (resetForm) resetForm();
        } else {
          // Handle errors and ensure errorMessage is a string
          const errorMessage =
            typeof responseData.message === "string"
              ? responseData.message
              : "Network response was not ok";

          throw new Error(errorMessage);
        }
      } catch (error) {
        // Ensure error.message is a string
        setAlert(`Failed to Post: ${String(error.message)}`, "error");
      }
      setLoading(false);
    },
    [fetchBusinessEntriesApiCall, resetForm]
  );
  const putEntry = useCallback(
    async (entryId, data, setActiveTab) => {
      setLoading(true);
      const url = `${URLs.baseUrl}/api/entriesupdate${entryId}`;
      try {
        const response = await fetch(url, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`,
          },
          body: JSON.stringify(data),
        });

        if (response.ok) {
          setAlert("Updated Successfully", "success"); // Successful update alert
          fetchBusinessEntriesApiCall(fromDate, toDate); // Fetch updated entries
          setActiveTab(0);
          if (resetForm) resetForm();
        } else {
          // Parse the error message from the JSON response
          const errorData = await response.json();
          const errorMessage = errorData.message || "Failed to Update"; // Use the server error message
          setAlert(errorMessage, "error"); // Show the error message in an alert
        }
      } catch (error) {
        setAlert("Failed to Update: " + error.message, "error"); // Handle network or other errors
      }
      setLoading(false);
    },
    [fetchBusinessEntriesApiCall, resetForm]
  );
  const deleteEntry = useCallback(
    async (entryId) => {
      setLoading(true);
      const url = `${URLs.baseUrl}/api/businessEntries/${entryId}`;
      try {
        const response = await fetch(url, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`,
          },
        });

        if (response.ok) {
          setAlert("Deleted Successfully", "success");
          fetchBusinessEntriesApiCall(fromDate, toDate);
          if (resetForm) resetForm();
        } else {
          // If the response is not ok, parse the response body to get the error message
          const errorData = await response.json();
          setAlert(errorData.message || "Failed to Delete", "error");
        }
      } catch (error) {
        setAlert("Failed to Delete: " + error.message, "error");
      }
      setLoading(false);
    },
    [fetchBusinessEntriesApiCall]
  );
  const fetchDsaMasterData = async () => {
    const url = URLs.dsaMasterGetUrl;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };
    setLoading(true);
    try {
      const response = await fetch(url, options);
      const data = await response.json();
      const filteredDsaData = data.data.filter((item) => item.dsaType == "CNT");
      setSubDsaData([{ dsaName: "Direct", dsaId: 0 }, ...filteredDsaData]);
    } catch (error) {
      setAlert("Failed to fetch data", "error");
    }
    setLoading(false);
  };
  const postDsaMasterApiCall = async (connectorFormData, setConnectorFormData) => {
    const url = URLs.dsaMasterGetUrl;
    const newDsa = {
      dsaId: 0,
      dsaType: "CNT",
      dsaCode: connectorFormData.connectorId,
      dsaName: connectorFormData.connectorName,
      dsaStatus: "K".charAt(0),
      panNumber: connectorFormData.panNumber,
      gststatus: connectorFormData.hasGST ? "Y" : "N",
      gstnumber: connectorFormData.gstNumber,
      contactpersonName: "",
      address: {
        street: "",
        city: "",
        state: "",
      },
      phoneNumber: "",
      emailId: "",
    };

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
      body: JSON.stringify(newDsa),
    };

    setLoading(true); // Start loading

    try {
      const response = await fetch(url, options);
      const responseData = await response.json();

      if (response.ok) {
        fetchDsaMasterData(); // Refresh the DSA master list
        setConnectorFormData({
          connectorId: "",
          connectorName: "",
          panNumber: "",
          hasGST: false,
          gstNumber: "",
        });
        setAlert(responseData.message || "Posted successfully", "success"); // Show server message
      } else {
        const errorMessage = responseData.message || "Failed to post DSA data";
        throw new Error(errorMessage); // Throw error with message from server
      }
    } catch (error) {
      setAlert("Failed to Post: " + error.message, "error"); // Show error message
    }
    setLoading(false);
  };

  useEffect(() => {
    if (typeCode) {
      fetchEntriesFeildsData();
      fetchCompanyConfigs();
      if (typeCode === "IN") {
        fetchInsuranceAgents(user.companyId);
      }
    }
  }, [fetchEntriesFeildsData]);

  return {
    businessMasterData,
    providerData,
    dsaData,
    entryData,
    subDsaData,
    managersData,
    dsaManagersData,
    companyConfig,
    message,
    alertType,
    open,
    editStatus,
    finalFinanceData,
    fetchInsuranceConfigs,
    insuranceConfigs,
    fetchInsuranceAgents,
    insuranceAgents,
    setLoading,
    loading,
    setAlert,
    handleClose,
    setEditStatus,
    setOpen,
    postEntry,
    postInsuranceEntry,
    putEntry,
    deleteEntry,
    postDsaMasterApiCall,
    fetchFinanceDetails,
    fetchBusinessEntriesApiCall,
    fetchInsuranceEntriesApiCall,
    deleteInsuranceEntry,
    putInsuranceEntry,
    fetchFilteredFinanceDetails,
    handleClose,
  };
};

export default useBusinessEntryApiCall;
